// extracted by mini-css-extract-plugin
export var quote = "quote-module--quote--2Xg5F";
export var credit = "quote-module--credit--24CXg";